import { render, staticRenderFns } from "./List-Pre-Order.vue?vue&type=template&id=22c40445"
import script from "./List-Pre-Order.vue?vue&type=script&lang=js"
export * from "./List-Pre-Order.vue?vue&type=script&lang=js"
import style0 from "./List-Pre-Order.vue?vue&type=style&index=0&id=22c40445&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports